import classNames from 'classnames'
import { forwardRef } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'

import { useAppSelector } from '@/store/hooks'
import { CardListType } from '@/types/page'

import styles from './JumpTo.module.scss'

type CustomDropdownToggleProps = {
  children: React.ReactNode
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

const CustomDropdownToggle = forwardRef(({ children, onClick }: CustomDropdownToggleProps, ref) => (
  // @ts-ignore
  <div className='cursor-pointer dropdown-toggle ms-1' onClick={onClick} ref={ref}>
    {children}
  </div>
))

CustomDropdownToggle.displayName = 'CustomDropdownToggle'

type Props = {
  cardLists?: CardListType[]
  currentElementIndexInViewport?: number
  hideHeader?: boolean
}

const JumpTo = ({ cardLists, currentElementIndexInViewport, hideHeader }: Props) => {
  const updatedAt = useAppSelector((state) => state.cardlists.updatedAt)

  // No updatedAt during initial load
  if (!cardLists || !updatedAt) {
    return <div className={classNames(styles.container, 'shadow-sm')}></div>
  }

  const { header, tag } =
    cardLists[(currentElementIndexInViewport as number) >= 0 ? (currentElementIndexInViewport as number) : 0]

  return (
    <div className={classNames(styles.container, 'shadow-sm')}>
      {cardLists.length > 1 && (
        <Dropdown>
          {!hideHeader && <Dropdown.Toggle as={CustomDropdownToggle}>{header}</Dropdown.Toggle>}
          <Dropdown.Menu>
            {cardLists.map((cardList, i) => {
              const href = i === 0 ? '#cardlists' : cardList.href || `#${cardList.tag}`
              return (
                <Dropdown.Item href={href} key={i}>
                  <span className={classNames({ [styles.active]: cardList.tag === tag })}>{cardList.header}</span>
                </Dropdown.Item>
              )
            })}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  )
}

export default JumpTo
